import React from "react";

import Header from "../../general/Header";
import Aside from "../../general/Aside";
import Footer from "../../general/Footer";
import axios from '../../../axios/axiosconf';
import { useEffect, useState } from "react";
import { useHistory } from "react-router";
import { Link, useLocation } from "react-router-dom";
import Loading from "../../general/Loading";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

function EditarOtroDocumento() {

    const queryParams = new URLSearchParams(window.location.search);
    const [loading, setLoading] = useState(false);
    const [loggedIn, setLoggedIn] = useState(false);
    const [client, setClient] = useState([]);
    const search = useLocation().search;
    const id = new URLSearchParams(search).get('id');
    
    const [titulo, setTitulo] = useState('');
    const [contenido, setContenido] = useState('');
    const [errorlist, setErrorlist] = useState({});

    const LIMITE_CONTENIDO_PLANTILLA = 200000;
    const LIMITE_TITULO_PLANTILLA = 100;

    const longitudContenido = () => String(contenido || '').length;
    const contenidoExcedeLimite = () => longitudContenido() > LIMITE_CONTENIDO_PLANTILLA;

    let history = useHistory();

    let userdata = [];

    useEffect(()=>{

        if (localStorage.getItem('userdata')) {
            userdata = JSON.parse(localStorage.getItem('userdata'));
        }

        const config = {
            headers: {
                Authorization: 'Bearer ' + userdata.access_token
            }
        }

        
        axios.get('/get-client?uid='+userdata.user_id, config)
            .then(response => {
                if (response.status===200) {
                    
                    setClient(response.data);
                    setLoggedIn(true);
                }
            })
            .catch(error => {
                console.log(error);
            });
        
        const config2 = {
            params: {
                uid: userdata.user_id,
                id: id
            }
        }

        axios.get('/plantilla-otro-documento',config2)
            .then(response => {
                setTitulo(response.data[0].titulo);
                setContenido(response.data[0].contenido);
            })
            .catch(error => {
                console.log(error);
            });
    },[]);


    const handleSubmit = (e) => {
        e.preventDefault();
        if (contenidoExcedeLimite()) {
            setErrorlist({
                contenido: [`El contenido no puede superar ${LIMITE_CONTENIDO_PLANTILLA} caracteres.`]
            });
            return;
        }
        setLoading(true);

        const conf = {
            headers: { Authorization: 'Bearer ' + userdata.access_token },
            uid: userdata.user_id,
            id: id,
            titulo: titulo,
            contenido: contenido
        };
        
        axios.put('/plantilla-otro-documento', conf)
            .then(
                response => {
                    setLoading(false);
                    localStorage.setItem('toastmsg', 'La Plantilla "'+titulo+'" Ha Sido Modificada');
                    history.push('/plantillas-otros-documentos');
                }
            )
            .catch(
                err => {
                    if (err.response && err.response.data && err.response.data.errors) {
                        setErrorlist(err.response.data.errors);
                    } else {
                        setErrorlist({});
                    }
                    setLoading(false);
                }
            )
    }

    const contenidoHandler = (event, editor) => {
        setContenido(editor.getData());
        if (errorlist.contenido) {
            setErrorlist((prev) => {
                const next = { ...prev };
                delete next.contenido;
                return next;
            });
        }
    }


    if (loggedIn) {
        return (
            
            <div className="hold-transition">
                <Header client={client} />
                <Aside client={client} activelink="settings" />
                
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item" key="bc1"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item" key="bc2"><Link to="/settings">Configuración</Link></li>
                                        <li className="breadcrumb-item" key="bc3"><Link to="/administrar-plantillas">Administrar Plantillas</Link></li>
                                        <li className="breadcrumb-item" key="bc4"><Link to="/plantillas-otros-documentos">Otros Documentos</Link></li>
                                        <li className="breadcrumb-item" key="bc5">Editar Otro Documento</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2">
                                <div className="col-sm-8">
                                    <h1 className="m-0">Editar Otro Documento</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content" >
                        <div className="container-fluid">

                            <div className="row">
                            <div className="col-md-12">
                                
                                <div className="card">
                                <div id="infobasica">
                                    <div className="card-body">

                                        <form id="role-form" onSubmit={handleSubmit}>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="titulo">Título</label>
                                                        <input
                                                            type="text"
                                                            name="titulo"
                                                            className="form-control"
                                                            value={titulo}
                                                            id="titulo"
                                                            maxLength={LIMITE_TITULO_PLANTILLA}
                                                            onChange={(e) => setTitulo(e.target.value)}
                                                            required
                                                        />
                                                        {errorlist.titulo && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.titulo}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="form-group">
                                                        <label htmlFor="contenido">Contenido</label>
                                                        <CKEditor editor={ClassicEditor} onChange={contenidoHandler} data={contenido} />
                                                        <small className={`form-text ${contenidoExcedeLimite() ? 'text-danger font-weight-bold' : 'text-muted'}`}>
                                                            {longitudContenido()} / {LIMITE_CONTENIDO_PLANTILLA} caracteres
                                                        </small>
                                                        {errorlist.contenido && (
                                                            <div className="invalid-feedback visible">
                                                                {errorlist.contenido}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row" style={{marginTop: '30px'}}>
                                                <div className="col-md-6">
                                                    <Link to="/plantillas-otros-documentos" className="btn btn-secondary" style={{marginRight: '10px'}}>
                                                        Cancelar
                                                    </Link>
                                                    <button type="submit" className="btn btn-primary" disabled={loading || contenidoExcedeLimite()}>
                                                        Guardar Cambios&nbsp;
                                                        {loading ? (<span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>) : null }
                                                        
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                </div>

                            </div>          
                            </div>

                        </div>
                    </section>
                </div>
                <Footer showToast={false} delay={0} />
            </div>
            
        );
    }

    return (
        <Loading />
    );
}
export default EditarOtroDocumento;
